import callApi from 'common/callApi';

// export const getMenu = menuId =>
//   dispatch => dispatch(callApi(`v1/EventMenu/${menuId}`))
//     .then(result => result.json());

export const getMenu = (eventLinkId, menuId) =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${eventLinkId}/menu/${menuId}`))
    .then(result => result.json());
